export default "__VITE_ASSET__hlihtKcn__"